<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/personPerformanceLineList' }">人员绩效调整</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <div>
                        <el-button size="small" plain @click="insert">新增</el-button>
                        <el-button size="small" plain @click="update">编辑</el-button>
                        <el-button size="small" plain @click="del">删除</el-button>
                        <draggableDetail :draggable="{ data_name: 'person_performance_line' }" @isErrshow="reload"></draggableDetail>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="in_array(item.prop, ['person_name', 'person_performance_id'])"
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <!-- <el-collapse-item disabled title="子级信息" name="2">
                    <xxxxx v-if="flag" :postList="postList"></xxxxx> 
                </el-collapse-item> -->
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
export default {
    inject: ['reload'],
    name: 'personPerformanceLineDetail',
    components: {
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1'],
            data: {},
            queryParams: {},
            headerTitle: '人员绩效调整详情',
            flag: false,
            postList: {}
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.id = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.getData(); //获取详情
        });
    },
    methods: {
        in_array,
        toDetail(prop) {
            if (in_array(prop, ['person_name']) && this.data.person_rid) {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: this.data.person_rid
                    }
                });
            } else if (in_array(prop, ['person_performance_id']) && this.data.person_performance_id) {
                this.$router.push({
                    path: '/personPerformanceDetail',
                    query: {
                        id: this.data.person_performance_id
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.id = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).person_performance_line;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .personPerformanceLineDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.id;
                    this.flag = true;
                })
                .catch((error) => {});
        },
        //新增
        insert() {
            this.$router.push({
                path: 'personPerformanceLineEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //编辑
        update() {
            this.$router.push({
                path: 'personPerformanceLineEdit',
                query: {
                    type: 'update',
                    id: this.data.id
                }
            });
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'personPerformanceLineDelete', this.data.id, 'personPerformanceLineList');
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>